import React from 'react';
import { Container, Nav, Navbar, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Usuario from '../../model/Usuario/Usuario';
import { useAuth } from '../../hooks/useAuth';
import TooltipWrapper from '../TooltipWrapper';
import styles from './NavBarTop.module.scss';
import './styles.css';
import { BiSolidDoorOpen } from 'react-icons/bi';


interface NavBarProps {
  user: Usuario;
}

const NavBarTop: React.FC<NavBarProps> = ({ user }) => {
  const { logout } = useAuth();

  return (
    <Navbar className={`shadow p-3 mb-3 bg-body sticky-top ${styles.Navbar}`}>
      <Container fluid>
        <Navbar.Brand href="#home"></Navbar.Brand>
        <Navbar.Toggle />
        <Navbar.Collapse className="justify-content-start" id="basic-navbar-nav" />
        <a href='https://direitoshumanos.unicamp.br/' style={{marginRight: '35px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)'}}>
          { /*<img src={logotipo_dedh} alt='' style={{ maxWidth: '75px', height: 'auto' }} /> */ }
        </a>
        {/* Email do Usuário */}
        <TooltipWrapper tooltipContent={user.nome} tooltipPlacement="bottom">
          <Nav
            style={{
              border: '1px solid gray',
              paddingRight: '12px',
              paddingLeft: '12px',
              paddingTop: '8px',
              paddingBottom: '8px',
              borderRadius: '8px',
              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
              color: 'black',              
            }}
          >
            {user.email}
          </Nav>
        </TooltipWrapper>
        <div style={{ marginRight: '35px' }}></div>

        {/* Botão de Logout */}
        <OverlayTrigger
          placement="bottom"
          overlay={<Tooltip id="tooltip-logout">Sair</Tooltip>}
        >
          <Nav style={{ border: '1px solid gray', borderRadius: '8px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)' }}>
            <Nav.Link onClick={logout}>
              <BiSolidDoorOpen size={22} />
            </Nav.Link>
          </Nav>
        </OverlayTrigger>

      </Container>

    </Navbar>
  );
};

export default NavBarTop;
